// What the bottom ActionBar shows for a drill state. Pure: the screen maps the
// tapped slot back to an action in onPrimaryAction/onSecondaryAction.

function slots (d, isPlaying, loadingStalled) {
  const s = d.status;
  const pausePlay = isPlaying
    ? { icon: 'fa-pause', label: 'Pause', variant: 'navy' }
    : { icon: 'fa-play', label: 'Play', variant: 'gold' };

  if (s === 'ready') {
    return { prevGhost: true, secondary: null, primary: { icon: 'fa-play', label: 'Play', variant: 'gold' } };
  }
  if (s === 'listen') {
    return { prevGhost: false, secondary: { icon: 'fa-redo', label: 'Replay' }, primary: pausePlay };
  }
  if (s === 'speak') {
    if (d.scoring) {
      return {
        prevGhost: true,
        secondary: null,
        primary: { icon: 'fa-circle-notch', label: 'Scoring', variant: 'navy', inert: true }
      };
    }
    // Slot rule (STORY-004): primary is forward, secondary is recovery, so
    // Replay keeps the left seat it has in 'listen'. Reset takes the
    // primary seat (navy: speak has no forward action; Done is the ring).
    // No branching on asrError/showEmptyHint: the mic is live again, so
    // the bar must not change shape under someone already talking.
    return {
      prevGhost: false,
      secondary: { icon: 'fa-redo', label: 'Replay' },
      primary: { icon: 'fa-undo', label: 'Reset', variant: 'navy' }
    };
  }
  if (s === 'feedback') {
    // Held before replay: nothing playing yet, so an inert label.
    if (d.replayPending) {
      return {
        prevGhost: false,
        secondary: null,
        primary: { icon: 'fa-volume-up', label: 'Playing', variant: 'navy', inert: true }
      };
    }
    // BUGFIX-003 §3: a real Pause/Play during replay, not an inert label.
    if (d.replaying) return { prevGhost: false, secondary: null, primary: pausePlay };
    // Always Next, never a red Retry, so the button can't change identity
    // under the user's thumb.
    return {
      prevGhost: false,
      secondary: { icon: 'fa-redo', label: 'Retry' },
      primary: { icon: 'fa-step-forward', label: 'Next', variant: 'gold' }
    };
  }
  if (s === 'unsupported') {
    return {
      prevGhost: true,
      secondary: d.errorCode !== 'NO_TRANSCRIPT' ? { icon: 'fa-redo', label: 'Retry' } : null,
      primary: { icon: 'fa-film', label: 'Choose video', variant: 'gold' }
    };
  }
  if (s === 'micBlocked') {
    return { prevGhost: true, secondary: null, primary: { icon: 'fa-microphone', label: 'Try again', variant: 'gold' } };
  }
  if (s === 'done') {
    return {
      prevGhost: true,
      secondary: { icon: 'fa-film', label: 'Other video' },
      primary: { icon: 'fa-redo', label: 'Again', variant: 'gold' }
    };
  }
  // BUGFIX-003 §1: a stalled load gets the same escape hatch as unsupported.
  if (s === 'loading' && loadingStalled) {
    return {
      prevGhost: true,
      secondary: { icon: 'fa-redo', label: 'Retry' },
      primary: { icon: 'fa-film', label: 'Choose video', variant: 'gold' }
    };
  }
  return { prevGhost: true, secondary: null, primary: null };
}

/**
 * @returns {{prevGhost, nextGhost, secondary, primary, countdown}} ActionBar props
 */
export function barConfig (d, { isPlaying, loadingStalled }) {
  const s = d.status;
  const config = slots(d, isPlaying, loadingStalled);
  config.countdown = (d.autoAdvancing || d.autoRetrying) && !d.replaying && !d.replayPending;
  // Next rail is live only where the primary button isn't already Next.
  config.nextGhost = !(s === 'listen' || s === 'speak' ||
    (s === 'feedback' && (d.replaying || d.replayPending)));
  return config;
}
